import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchHiredlyXContent } from "../../../redux/actions/company_action";
import {
  ButtonStyled,
  CardListContainer,
  CardText,
  CardTextContainer,
  GridContainerStyled,
} from "./styles";

let query = `
  textBannerSection{
      title
  }
`;

export default function HXTextBanner(props) {
  const { onScrollToPackage } = props;
  const [solutions, setSolutions] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = await dispatch(fetchHiredlyXContent(query));

    const { textBannerSection } = response || {};
    setSolutions(textBannerSection);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Book A Free Consultation";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  function triggerInfoDialog() {
    onScrollToPackage();
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      {solutions?.map((cards, cardIndex) => (
        <CardListContainer key={cardIndex} cardNumber={cardIndex}>
          <CardTextContainer>
            <CardText
              type={"title"}
              cardNumber={cardIndex}
              dangerouslySetInnerHTML={{ __html: cards?.title }}
            ></CardText>
          </CardTextContainer>

          <ButtonStyled onClick={triggerInfoDialog}>{buttonCTA}</ButtonStyled>
        </CardListContainer>
      ))}
    </GridContainerStyled>
  );
}
